module.exports = __webpack_public_path__ + "static/Crystal3-c0893dc0db1189b5c3ca0510c7823af5.png";